socialFieldsSettingDirective = angular.module('socialfields.setting', [])

socialFieldsSettingDirective.filter 'toArray',["$timeout", ($timeout) ->
  (obj) ->
    result = []
    _.each obj, (val, hash) ->
      result.push {name: val, value: hash}
    result
]

socialFieldsSettingDirective.directive "socialFieldsSetting", ["$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "ContentEditable", ($window, $timeout, $compile, $templateCache, ns, translitService, ContentEditable) ->
  restrict: "A",
  scope: {data: "=ngModel"},
  templateUrl: "#{settingFolder}/socialfields/template.jade"
  link: (scope, element, attrs, ngModel) ->
    id = attrs.widgetId
    widgetElWrapper = angular.element("[data-block-id=#{id}]").find ns.widgetWrapperClass
    scope.social = angular.copy scope.data
    listener = scope.$watch "data", (newVal) ->
      renderIcons newVal
    , true
    scope.$on "$destroy", ->
      listener()
    renderIcons = (newVal) ->
      widgetSocialWrapper = widgetElWrapper.find ".strw__social-wrapper"
      iconsHtml = ""
      _.each newVal.icons_attributes, (icon) ->
        if icon.enabled
          color = if newVal.color_type is "custom" then newVal.style_attributes.color else icon.style_attributes.color
          iconHtml = "<a href='javascript:void(0)' class='strw__social-link' style='color: #{color};'><span class='strw__social-icon'>#{icon.content}</span></a>"
          iconsHtml += iconHtml
      widgetSocialWrapper.html iconsHtml
      widgetSocialWrapper.find(".strw__social-link").css margin: newVal.icons_margin
]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/socialfields/socialfields.directive.coffee